import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import Drawer from '@material-ui/core/Drawer';
import { getAccessibleMenuGroups } from '../../helpers/roles';

import './Sidebar.scss';

class Sidebar extends Component {

    render() {
        const { open, onClick, userRole } = this.props;
        
        const menuGroups = getAccessibleMenuGroups(userRole);

        return (
            <div>
                <Drawer
                    open={open}
                    onClose={onClick}
                    classes={{
                        root: 'sidebar_wrapper',
                        paper: 'sidebar_paper',
                        paperAnchorLeft: 'sidebar_paper_left',
                    }}
                >
                    <div>
                        <div className="burger-button-default burger-button-default_open  burger-button-default_sidebar " onClick={onClick}>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                        {menuGroups.map((group, groupIndex) => (
                            <React.Fragment key={groupIndex}>
                                {group.map((item) => (
                                    <p key={item.section}>
                                        <NavLink 
                                            to={item.path} 
                                            className="linkClass" 
                                            onClick={onClick}
                                        >
                                            {item.label}
                                        </NavLink>
                                    </p>
                                ))}
                                {groupIndex < menuGroups.length - 1 && (
                                    <div className="line_side_bar"></div>
                                )}
                            </React.Fragment>
                        ))}
                    </div>

                </Drawer>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        userRole: state.user.current_user.role,
    };
}

export default connect(mapStateToProps)(Sidebar);
